import { get, post } from '../apiClient';
import type {
  AmplifyOrganizationResult,
  AmplifyOrgUsersResult,
  BridgeAnalysisResult,
  UserMigrationDryRunResult,
} from '@/types';

export interface OrgUsersFilters {
  status?: string | undefined;
  email?: string | undefined;
  page?: number | undefined;
}

export const customerIntelApi = {
  getAmplifyOrg: (uuid: string) =>
    get<AmplifyOrganizationResult>(`/customer-intelligence/amplify-org/${uuid}`),

  getOrgUsers: (uuid: string, filters: OrgUsersFilters = {}) =>
    get<AmplifyOrgUsersResult>(`/customer-intelligence/amplify-org/${uuid}/users`, filters),

  getBridgeAnalysis: (uuid: string) =>
    get<BridgeAnalysisResult>(`/customer-intelligence/bridge-analysis/${uuid}`),

  runUserMigrationDryRun: (uuid: string) =>
    post<UserMigrationDryRunResult>(
      `/customer-intelligence/bridge-analysis/${uuid}/user-migration-dry-run`,
    ),
};

export const customerIntelKeys = {
  all: ['customer-intelligence'] as const,
  amplifyOrg: (uuid: string) => [...customerIntelKeys.all, 'amplify-org', uuid] as const,
  orgUsers: (uuid: string, filters: OrgUsersFilters) =>
    [...customerIntelKeys.all, 'org-users', uuid, filters] as const,
  bridgeAnalysis: (uuid: string) => [...customerIntelKeys.all, 'bridge-analysis', uuid] as const,
  userMigrationDryRun: (uuid: string) =>
    [...customerIntelKeys.all, 'user-migration-dry-run', uuid] as const,
};
